// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-title-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3em;
    padding-bottom: 2em;
}

.contact-title-section .paragraph {
    text-align: center;
    margin-top: 2%;
    font-size: 16px;
}

.contact-chat-box,
.contact-email-box {
    padding: 4em;
    flex-direction: column;
    text-align: center;
    margin-top: -2em;
}

.contact-chat-box .title-header,
.contact-email-box .title-header {
    padding-bottom: 2%;
    padding-top: 0%;
}

.contact-chat-box .paragraph,
.contact-email-box .paragraph {
    padding-bottom: 5%;
}

.fwc-col-12.contact-box-layout {
    padding: 4em;
}

.contact-icon-box {
    width: 130px;
    display: flex;
    background: #fff;
    border-radius: 65px;
    height: 130px;
    align-self: center;
    margin-top: -65px;
}

.contact-icon-box-inner {
    width: 110px;
    display: flex;
    background: #EEEEEE;
    border-radius: 55px;
    height: 110px;
    justify-content: center;
    margin: 10px;
    align-items: center;
}

.contact-email-box .field-select {
    margin-bottom: 0px !important;
}

.fwc-col-12.contact-box-contact .fwc-row {
    max-width: 100%;
    width: 100%;
    padding-left: 48px;
    padding-right: 48px;
    padding-top: 24px;
    padding-bottom: 24px;
}

.contact-box-email-contact .fwc-row {
    max-width: 100%;
    width: 100%;
    padding-left: 48px;
    padding-right: 48px;
    padding-top: 24px;
    padding-bottom: 24px;
}

.fwc-col-12.contact-box-contact {
    margin-top: 4%;
    margin-bottom: 4%;
}

.contact-list-box {
    margin-bottom: 3em;
}

td.listText {
    text-transform: capitalize;
}

table.fwc-table.contact-table tr {
    background: transparent;
    padding: 0px;
}

table.fwc-table.contact-table td {
    padding: 0px;
    border: 0px !important;
    font-size: 16px;
    height: 1.5em;
}

.contact-list-box .title-header {
    padding-bottom: 2%;
}

.contact-list-box .paragraph {
    padding-bottom: 2%;
    font-size: 16px !important;
}

.contact-list-select {
    margin-top: 15px;
}

p.paragraph.contact-list-paragraph {
    margin-top: 5px;
    font-size: 16px;
}

.contact-box-contact .paragraph {
    margin-top: 10px;
}

.contact-list-button-box {
    justify-content: center;
    flex: 1;
    display: flex;
}

.contact-icon-box-inner .fwc-icon {
    font-size: 4em;
}

.enableMargin {
    margin-top: -20px;
}

.contact-loading-block {
    justify-content: center;
    min-height: 250px;
    flex: 1;
}

.contact-box-contact .paragraph,
.contact-title-section .paragraph,
.contact-chat-box .paragraph,
.contact-email-box .paragraph {
    margin-top: 10px;
    font-size: 16px !important;
}

.contact-error-block {
    flex: 1;
    justify-content: center;
    text-align: center;
    min-height: 150px;
}

.contact-error .paragraph {
    margin-top: 1%
}

.contact-error {
    margin-bottom: 5%;
}

.contact-footer-section {
    text-align: center;
    display: flex;
    flex-direction: inherit;
    justify-content: center;
    align-items: center;
    padding-left: 5%;
    padding-right: 5%;
    padding-bottom: 5em;
}

.contact-footer-section .paragraph {
    font-size: 16px !important;
}

.contact-list-button-box {
    justify-content: end;
    padding: 1em !important;
}

.contact-footer-section .infoIcon {
    padding: 5px;
    color: #003798;
    font-size: 20px;
}

@media screen and (max-width: 600px) {
    .fwc-col-12.contact-box-layout {
        padding: 0;
        margin-top: 6em;
        margin-bottom: 3em;
    }

    .fwc-col-12.contact-box-contact .fwc-row {
        max-width: 100%;
        width: 100%;
        padding-left: 12px;
        padding-right: 12px;
        padding-top: 24px;
        padding-bottom: 24px;
    }

    .contact-box-email-contact .fwc-row {
        max-width: 100%;
        width: 100%;
        padding-left: 12px;
        padding-right: 12px;
        padding-top: 24px;
        padding-bottom: 24px;
    }

    .fwc-col-3.md-3.sm-12.contact-list-button-box {
        margin-top: 20px;
        justify-content: center;
    }

    .fwc-col-12.contact-box-email-contact {
        margin-bottom: 4em;
    }

    .contact-icon-box {
        width: 120px;
        border-radius: 60px;
        height: 120px;
    }

    .contact-icon-box-inner {
        width: 100px;
        border-radius: 50px;
        height: 100px;
    }

    .contact-chat-box,
    .contact-email-box {
        padding: 2.5em;
        margin-top: -2em;
    }

    .contact-title-section {
        padding: 4%;
        padding-top: 3em;
        padding-bottom: 2em;
    }

    .contact-list-button-box {
        justify-content: end;
        padding: 1em;
    }

    .contact-footer-section {
        padding-bottom: 2em;
    }

    .fwc-row.a-start.contact-box {
        margin-bottom: 10em;
    }
}`, "",{"version":3,"sources":["webpack://./client/contactus/V2/ContactUs.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,OAAO;AACX;;AAEA;;;;IAII,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,OAAO;IACP,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,aAAa;IACjB;;IAEA;;QAEI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".contact-title-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 3em;\n    padding-bottom: 2em;\n}\n\n.contact-title-section .paragraph {\n    text-align: center;\n    margin-top: 2%;\n    font-size: 16px;\n}\n\n.contact-chat-box,\n.contact-email-box {\n    padding: 4em;\n    flex-direction: column;\n    text-align: center;\n    margin-top: -2em;\n}\n\n.contact-chat-box .title-header,\n.contact-email-box .title-header {\n    padding-bottom: 2%;\n    padding-top: 0%;\n}\n\n.contact-chat-box .paragraph,\n.contact-email-box .paragraph {\n    padding-bottom: 5%;\n}\n\n.fwc-col-12.contact-box-layout {\n    padding: 4em;\n}\n\n.contact-icon-box {\n    width: 130px;\n    display: flex;\n    background: #fff;\n    border-radius: 65px;\n    height: 130px;\n    align-self: center;\n    margin-top: -65px;\n}\n\n.contact-icon-box-inner {\n    width: 110px;\n    display: flex;\n    background: #EEEEEE;\n    border-radius: 55px;\n    height: 110px;\n    justify-content: center;\n    margin: 10px;\n    align-items: center;\n}\n\n.contact-email-box .field-select {\n    margin-bottom: 0px !important;\n}\n\n.fwc-col-12.contact-box-contact .fwc-row {\n    max-width: 100%;\n    width: 100%;\n    padding-left: 48px;\n    padding-right: 48px;\n    padding-top: 24px;\n    padding-bottom: 24px;\n}\n\n.contact-box-email-contact .fwc-row {\n    max-width: 100%;\n    width: 100%;\n    padding-left: 48px;\n    padding-right: 48px;\n    padding-top: 24px;\n    padding-bottom: 24px;\n}\n\n.fwc-col-12.contact-box-contact {\n    margin-top: 4%;\n    margin-bottom: 4%;\n}\n\n.contact-list-box {\n    margin-bottom: 3em;\n}\n\ntd.listText {\n    text-transform: capitalize;\n}\n\ntable.fwc-table.contact-table tr {\n    background: transparent;\n    padding: 0px;\n}\n\ntable.fwc-table.contact-table td {\n    padding: 0px;\n    border: 0px !important;\n    font-size: 16px;\n    height: 1.5em;\n}\n\n.contact-list-box .title-header {\n    padding-bottom: 2%;\n}\n\n.contact-list-box .paragraph {\n    padding-bottom: 2%;\n    font-size: 16px !important;\n}\n\n.contact-list-select {\n    margin-top: 15px;\n}\n\np.paragraph.contact-list-paragraph {\n    margin-top: 5px;\n    font-size: 16px;\n}\n\n.contact-box-contact .paragraph {\n    margin-top: 10px;\n}\n\n.contact-list-button-box {\n    justify-content: center;\n    flex: 1;\n    display: flex;\n}\n\n.contact-icon-box-inner .fwc-icon {\n    font-size: 4em;\n}\n\n.enableMargin {\n    margin-top: -20px;\n}\n\n.contact-loading-block {\n    justify-content: center;\n    min-height: 250px;\n    flex: 1;\n}\n\n.contact-box-contact .paragraph,\n.contact-title-section .paragraph,\n.contact-chat-box .paragraph,\n.contact-email-box .paragraph {\n    margin-top: 10px;\n    font-size: 16px !important;\n}\n\n.contact-error-block {\n    flex: 1;\n    justify-content: center;\n    text-align: center;\n    min-height: 150px;\n}\n\n.contact-error .paragraph {\n    margin-top: 1%\n}\n\n.contact-error {\n    margin-bottom: 5%;\n}\n\n.contact-footer-section {\n    text-align: center;\n    display: flex;\n    flex-direction: inherit;\n    justify-content: center;\n    align-items: center;\n    padding-left: 5%;\n    padding-right: 5%;\n    padding-bottom: 5em;\n}\n\n.contact-footer-section .paragraph {\n    font-size: 16px !important;\n}\n\n.contact-list-button-box {\n    justify-content: end;\n    padding: 1em !important;\n}\n\n.contact-footer-section .infoIcon {\n    padding: 5px;\n    color: #003798;\n    font-size: 20px;\n}\n\n@media screen and (max-width: 600px) {\n    .fwc-col-12.contact-box-layout {\n        padding: 0;\n        margin-top: 6em;\n        margin-bottom: 3em;\n    }\n\n    .fwc-col-12.contact-box-contact .fwc-row {\n        max-width: 100%;\n        width: 100%;\n        padding-left: 12px;\n        padding-right: 12px;\n        padding-top: 24px;\n        padding-bottom: 24px;\n    }\n\n    .contact-box-email-contact .fwc-row {\n        max-width: 100%;\n        width: 100%;\n        padding-left: 12px;\n        padding-right: 12px;\n        padding-top: 24px;\n        padding-bottom: 24px;\n    }\n\n    .fwc-col-3.md-3.sm-12.contact-list-button-box {\n        margin-top: 20px;\n        justify-content: center;\n    }\n\n    .fwc-col-12.contact-box-email-contact {\n        margin-bottom: 4em;\n    }\n\n    .contact-icon-box {\n        width: 120px;\n        border-radius: 60px;\n        height: 120px;\n    }\n\n    .contact-icon-box-inner {\n        width: 100px;\n        border-radius: 50px;\n        height: 100px;\n    }\n\n    .contact-chat-box,\n    .contact-email-box {\n        padding: 2.5em;\n        margin-top: -2em;\n    }\n\n    .contact-title-section {\n        padding: 4%;\n        padding-top: 3em;\n        padding-bottom: 2em;\n    }\n\n    .contact-list-button-box {\n        justify-content: end;\n        padding: 1em;\n    }\n\n    .contact-footer-section {\n        padding-bottom: 2em;\n    }\n\n    .fwc-row.a-start.contact-box {\n        margin-bottom: 10em;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
